import { useSoftDeployAccess } from 'App/components/hooks';
import { useMetadata } from 'App/components/hooks/appHooks';

/**
 * Whether the extension offers its Airscale lookups - Find email / Find phone number on a profile and
 * People at this company on a company page (WEB-13771): the Prospecting section, the Airscale flag,
 * and not an EU ONLY account, which Airscale is never called for (`resolveAirscaleKey`, WEB-13366).
 * Mirrors the server's gate so an account is not shown buttons that can only answer "not available";
 * the server still has the last word.
 */
export default function useAirscaleLookup(): boolean {
	const hasProspectingTools = useSoftDeployAccess('PROSPECTING_TOOLS');
	const hasAirscale = useSoftDeployAccess('AIRSCALE_INTEGRATION');
	const euOnly = useMetadata()?.params?.EuOnly === true;
	return hasProspectingTools && hasAirscale && !euOnly;
}
